import React from 'react'
import bgImage from '../../assets/images/background/image-13.jpg'
import bg4 from '../../assets/images/background/bg-28.png'
import { useContent } from '../../services'

function LiveSports() {
    const { data: sports, loading } = useContent('homeLiveSports');

    if (loading || !sports) return null;

    return (
        <section className="live-sports-section">
            <div className="outer-container">
                <div className="row clearfix">

                    {/* ── Left: Content Column ── */}
                    <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <div className="left-bg"><img src={bg4} alt="" /></div>
                        <div className="inner wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="0ms">
                            <div className="title-box">
                                <div className="subtitle"><span>{sports.subtitle}</span></div>
                                <div className="pattern-image">
                                    <img src={require('../../assets/images/icons/separator.svg').default} alt="" />
                                </div>
                                <h2>{sports.title}</h2>
                                <div className="text">{sports.text}</div>
                            </div>

                            {/* Sport tags */}
                            <div className="sports-tags">
                                {sports.sports.map((sport, i) => (
                                    <span key={i} className="sports-tag">
                                        <span className={sport.icon}></span>
                                        {sport.name}
                                    </span>
                                ))}
                            </div>

                            <div className="sports-highlight">
                                <span className="fas fa-tv"></span>
                                <span>{sports.highlight}</span>
                            </div>
                        </div>
                    </div>

                    {/* ── Right: Image Column ── */}
                    <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <div className="inner wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="0ms">
                            <div className="image-layer" style={{ backgroundImage: `url(${bgImage})` }}></div>
                            <div className="image"><img src={bgImage} alt="Live sports on the biggest screen in DFW at Huqup" /></div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default LiveSports
